const $win = $(window);
const $doc = $(document);
const $header = $('.header');
const mobileWidth = 768;
const tabletWidth = 1024;
const $menu = $('.nav .menu');

function navCollapse() {
	let navWidth = 0;
	let moreWidth = $('.menu__item--more').outerWidth(true);

	$menu.children(':not(.menu__item--more):not(.hidden)').each(function() {
		const $this = $(this);

		navWidth += $this.outerWidth(true);
	});

	let spaceLeft = $('.nav .container > .menu').width() - moreWidth;

	if (navWidth > spaceLeft) {
		while (navWidth > spaceLeft) {
			let $lastItem = $menu.children(':not(.menu__item--more):not(.hidden)').last();
			let index = $lastItem.data('index');

			$lastItem.addClass('hidden');

			$(`.menu__item--more li[data-index="${index}"]`).removeClass('hidden');

			navWidth -= $lastItem.data('width');
		}
	} else {
		let $firstMoreItem = $('.menu__item--more > .menu__dropdown > ul > li:not(.hidden)').first();
		let index = $firstMoreItem.data('index');

		if (navWidth + $(`.menu > li[data-index="${index}"`).data('width') < spaceLeft) {
			$firstMoreItem.addClass('hidden');

			$(`.menu > li[data-index="${index}"]`).removeClass('hidden');
		}
	}

	if ($('.menu__item--more > .menu__dropdown > ul > li:not(.hidden)').length > 0) {
		$('.menu__item--more').css('display', 'inline-block');
	} else {
		$('.menu__item--more').css('display', 'none');
	}
}

$menu.children(':not(.menu__item--more)').each(function() {
	const $this = $(this);

	$this.attr('data-width', Math.round($this.outerWidth(true)));
});

navCollapse();

$win.on('load resize', function() {
	if ($win.width() >= mobileWidth) {
		$('.menu__dropdown').css('display', '');
		$('.menu__item--has-dropdown, .header').removeClass('hovered active');
		$('body').removeClass('no-scroll');
		$('.wrapper').removeClass('overlay');
		$('.nav, .nav-trigger').removeClass('active');

		navCollapse();
	} else {
		$('.nav .menu > li').removeClass('hidden');
		$('.menu__item--more').addClass('hidden');
	}
});

$header
	.on('mouseenter touchend', '.nav .menu > .menu__item', function(e) {
		if ($win.width() < tabletWidth && $win.width() >= mobileWidth) {
			if (!$(this).hasClass('hovered')) {
				e.preventDefault();

				$(this)
					.siblings()
					.removeClass('hovered');
			}
		}

		if ($win.width() >= mobileWidth) {
			const $this = $(this);

			$this.add($('header')).addClass('hovered');

			if ($this.hasClass('menu__item--has-dropdown')) {
				$('.wrapper').addClass('overlay');
			}
		}
	})
	.on('mouseleave', '.nav .menu > .menu__item', function() {
		if ($win.width() >= mobileWidth) {
			const $this = $(this);

			$this.add($('header')).removeClass('hovered');
			$('.wrapper').removeClass('overlay');
		}
	})
	.on('click', '.nav-trigger', function(e) {
		e.preventDefault();

		const $this = $(this);

		$this.add('.nav').toggleClass('active');
		$('.wrapper').toggleClass('overlay');
		$('body').toggleClass('no-scroll');
	})
	.on('click', '.nav .menu__item--has-dropdown > a', function(e) {
		if ($win.width() < mobileWidth) {
			const $this = $(this);
			const $parent = $this.parent();

			if (!$this.hasClass('clicked')) {
				e.preventDefault();

				$('.clicked').removeClass('clicked');

				$this
					.addClass('clicked')
					.siblings('.menu__dropdown')
					.slideToggle();

				$parent
					.addClass('active')
					.siblings()
					.removeClass('active')
					.find('.menu__dropdown')
					.slideUp();
			}
		}
	})
	.on('click', '.nav .menu__close', function(e) {
		const $this = $(this);
		const $parent = $this.parent();

		$('.clicked')
			.not($this.siblings())
			.removeClass('clicked');

		$parent
			.toggleClass('active')
			.siblings()
			.removeClass('active')
			.find('.menu__dropdown')
			.slideUp();

		$this
			.prev()
			.toggleClass('clicked')
			.siblings('.menu__dropdown')
			.slideToggle();
	})
	.on('click', '.account-trigger', function(e) {
		e.preventDefault();

		const $this = $(this);

		$this.siblings('.menu__dropdown').toggleClass('is-visible');
	});

$doc
	.on('mouseup', function(e) {
		if ($('.nav-access .menu__dropdown.is-visible').length) {
			var container = $('.nav-access .menu__dropdown.is-visible');

			// if the target of the click isn't the container nor a descendant of the container
			if (!container.is(e.target) && container.has(e.target).length === 0) {
				container.removeClass('is-visible');
			}
		}

		if ($('.menu__item.hovered').length) {
			var container = $('.menu__item.hovered');

			// if the target of the click isn't the container nor a descendant of the container
			if (!container.is(e.target) && container.has(e.target).length === 0) {
				container.add($('header')).removeClass('hovered');
				$('.wrapper').removeClass('overlay');
			}
		}
	})
	.on('click touchend', function(event) {
		if ($('.nav.active').length) {
			clickHandlers.forEach(function(clickHandler) {
				hideElementOnDocumentClick(event, clickHandler);
			});
		}
	});

function hideElementOnDocumentClick(event, clickHandler) {
	var $target = $(event.target);
	var $wrapper = $('.wrapper');
	var $html = $('html, body');

	var elementClass = clickHandler.elementClass;
	var triggerClass = clickHandler.triggerClass;
	var elementVisibleClass = clickHandler.elementVisibleClass;
	var triggerActiveClass = clickHandler.triggerActiveClass;
	var globalVisibleClass = clickHandler.globalVisibleClass;

	if (
		!$target.hasClass(elementClass) &&
		!$target.parents('.' + elementClass).length &&
		!$target.hasClass(triggerClass) &&
		!$target.parents('.' + triggerClass).length
	) {
		$('.' + elementClass).removeClass(elementVisibleClass);
		$('.' + triggerClass).removeClass(triggerActiveClass);

		$wrapper.removeClass(globalVisibleClass);
		$html.removeClass(globalVisibleClass);
	}
}

/**
 * @param  {String} elementClass             Selector for the element to hide
 * @param  {String} triggerClass             Selector for the trigger
 * @param  {String} elementVisibleClass      Classname to remove from the element
 * @param  {String} triggerActiveClass       Classname to remove from the trigger
 * @param  {String} globalVisibleClass       Classname to remove from the `html` tag
 */
var clickHandlers = [
	{
		elementClass: 'nav',
		triggerClass: 'nav-trigger',
		elementVisibleClass: 'active',
		triggerActiveClass: 'active',
		globalVisibleClass: 'overlay no-scroll'
	}
];



// WEBPACK FOOTER //
// ../assets/js/navigation.js